import * as actionTypes from '@store/design/action-types';
import { Types } from '@store/types';

import {
	fetchAllSizeCategory,
	fetchLatestMeasurementTypeInfo,
	fetchSizeCategoryById
} from '@services/measurementService';

import ApiClient from '@lib/apiClient';

export const fetchAllSizeCategories = (params) => async (dispatch) => {
	const data = await fetchAllSizeCategory(params);
	dispatch({
		type: Types.FETCH_ALL_MEASUREMENT_CATEGORIES,
		payload: data
	});
};

export const fetchPomAndSize = (productId) => async (dispatch) => {
	try {
		dispatch({ type: actionTypes.FETCH_POM_AND_SIZE_REQUEST });
		const response = await ApiClient.GET('getPomSize', `?productId=${productId}`);
		dispatch({
			type: actionTypes.FETCH_POM_AND_SIZE_SUCCESS,
			payload: { pomResponseList: response.data }
		});
	} catch {
		dispatch({ type: actionTypes.FETCH_POM_AND_SIZE_FAILURE });
	}
};

export const fetchProductWiseMeasurementSizeInfo =
	(productId, measurementType, unitType = 'CM') =>
	async (dispatch) => {
		try {
			dispatch({ type: actionTypes.FETCH_POM_AND_SIZE_REQUEST });
			let params = '';
			if (measurementType) {
				params += `?measurementType=${measurementType}&unit=${unitType}`;
			}
			const data = await fetchLatestMeasurementTypeInfo(productId, params);
			dispatch(toggleMeasurementActualAndDiffColumn(data.showActual));
			dispatch(toggleBlockUsedFromInfo(data.showBlockUsedFromInfo));
			dispatch(hideMeasurementTableColumn(data.hiddenSizeIds));
			await dispatch({
				type: actionTypes.FETCH_POM_AND_SIZE_SUCCESS,
				payload: { measurementInfo: data, sizeCategoryId: data.sizeCategoryId }
			});
			await dispatch({
				type: Types.ADD_MEASUREMENT_SIZE_CATEGORY_SEQUENCE,
				payload: data.sizeCategorySequenceMap || {}
			});
			await dispatch({
				type: Types.FETCH_PRODUCT_MEASUREMENT_TABLE_DATA,
				payload: data?.tableData || []
			});
		} catch {
			dispatch({ type: actionTypes.FETCH_POM_AND_SIZE_FAILURE });
		}
	};

export const fetchProductWiseMeasurementSizeByCategoryId = (categoryId) => async (dispatch) => {
	try {
		dispatch({ type: actionTypes.FETCH_POM_AND_SIZE_REQUEST });
		const data = await fetchSizeCategoryById(categoryId);
		dispatch({
			type: actionTypes.FETCH_POM_AND_SIZE_SUCCESS,
			payload: { sizeCategory: data }
		});
	} catch {
		dispatch({ type: actionTypes.FETCH_POM_AND_SIZE_FAILURE });
	}
};

export const changeSelectedSizeCategoryId = (categoryId) => async (dispatch) => {
	dispatch({
		type: Types.CHANGE_MEASUREMENT_SIZE_CATEGORY_ID,
		payload: categoryId
	});
};

export const saveProductMeasurementTableData = () => async (dispatch) => {
	dispatch({
		type: Types.SAVE_PRODUCT_MEASUREMENT_TABLE_DATA,
		payload: {}
	});
};

export const saveProductMeasurementChangeLog = (data) => async (dispatch) => {
	dispatch({
		type: Types.ADD_PRODUCT_MEASUREMENT_CHANGE_LOG,
		payload: data
	});
};

export const saveProductMeasurementBulkChangeLog = (data) => async (dispatch) => {
	dispatch({
		type: Types.ADD_PRODUCT_MEASUREMENT_BULK_CHANGE_LOG,
		payload: data
	});
};

export const saveNewPointInMeasurementTable = (data) => async (dispatch) => {
	dispatch({
		type: Types.ADD_NEW_POINT_IN_MEASUREMENT_TABLE,
		payload: data
	});
};

export const replaceProductMeasurementChangeLog = (data) => async (dispatch) => {
	dispatch({
		type: Types.REPLACE_POM_IN_MEASUREMENT_TABLE,
		payload: data
	});
};

export const removePointInMeasurementTable = (pointId) => async (dispatch) => {
	dispatch({
		type: Types.REMOVE_POINT_IN_MEASUREMENT_TABLE,
		payload: pointId
	});
};

export const removeLibraryPointInMeasurementTable = (pointId) => async (dispatch) => {
	dispatch({
		type: Types.REMOVE_LIBRARY_POINT_IN_MEASUREMENT_TABLE,
		payload: pointId
	});
};

export const saveNewSizeInMeasurementTable = (payload) => async (dispatch) => {
	dispatch({
		type: Types.ADD_NEW_SIZE_IN_MEASUREMENT_TABLE,
		payload: payload
	});
};

export const modifyMeasurementTablePointIds = (payload) => async (dispatch) => {
	dispatch({
		type: Types.MODIFY_MEASUREMENT_TABLE_POINT_IDS,
		payload: payload
	});
};
export const modifyMeasurementTablePointCode = (payload) => async (dispatch) => {
	dispatch({
		type: Types.MODIFY_MEASUREMENT_TABLE_POINT_CODE,
		payload: payload
	});
};
export const modifyMeasurementTablePointName = (payload) => async (dispatch) => {
	dispatch({
		type: Types.MODIFY_MEASUREMENT_TABLE_POINT_NAME,
		payload: payload
	});
};

export const modifyMeasurementTableCellValue = (payload) => async (dispatch) => {
	dispatch({
		type: Types.MODIFY_MEASUREMENT_TABLE_CELL_VALUE,
		payload: payload
	});
};

export const reArrangeMeasurementTable = (payload) => async (dispatch) => {
	dispatch({
		type: Types.REARRANGE_MEASUREMENT_TABLE_ROW,
		payload: payload
	});
};

export const clearMeasurementTable = () => async (dispatch) => {
	dispatch({
		type: Types.CLEAR_MEASUREMENT_TABLE
	});
};

export const saveProductMeasurementBulkModifiedSizes = (data) => async (dispatch) => {
	dispatch({
		type: Types.MODIFY_MEASUREMENT_TABLE_BULK_SIZE_CELL_VALUE,
		payload: data
	});
};

export const addMeasurementGroupGrading = (data) => async (dispatch) => {
	dispatch({
		type: Types.ADD_MEASUREMENT_GROUP_GRADING,
		payload: data
	});
};

export const removeMeasurementGroupGrading = () => async (dispatch) => {
	dispatch({
		type: Types.REMOVE_MEASUREMENT_GROUP_GRADING,
		payload: {}
	});
};

export const changeCostingPpSampleBaseSize = (data) => async (dispatch) => {
	dispatch({
		type: Types.MODIFY_MEASUREMENT_BASE_SIZE,
		payload: data
	});
};

export const removeMeasurementSize = (data) => async (dispatch) => {
	dispatch({
		type: Types.REMOVE_MEASUREMENT_SIZE,
		payload: data
	});
};

export const pasteMeasurementSizeValues = (data) => async (dispatch) => {
	dispatch({
		type: Types.PASTE_MEASUREMENT_SIZE_VALUES,
		payload: data
	});
};

export const clearMeasurementChangeLog = () => async (dispatch) => {
	dispatch({
		type: Types.CLEAR_MEASUREMENT_CHANGE_LOG,
		payload: {}
	});
};

export const setMeasurementHistoryInfo = (data) => async (dispatch) => {
	dispatch({
		type: Types.SET_MEASUREMENT_HISTORY_INFO,
		payload: data
	});
};

export const toggleMeasurementActualAndDiffColumn = (data) => async (dispatch) => {
	dispatch({
		type: Types.SET_MEASUREMENT_SHOW_COLUMN_VALUE,
		payload: data
	});
};

export const setInitMeasurementTableId = (data) => async (dispatch) => {
	dispatch({
		type: Types.ADD_INIT_MEASUREMENT_ID,
		payload: data
	});
};

export const getFitInfoByPomId = (data, pomId) => {
	let fitInfo = {};
	for (let measurement of data) {
		for (let item of measurement.data) {
			if (item.pomResponse.id === pomId) {
				fitInfo[measurement.fitType.constant] = {
					pomResponseId: item.pomResponse.id,
					actualValue: item.actualValue,
					actualValueModified: item.actualValueModified,
					grading1Modified: item.grading1Modified,
					grading2Modified: item.grading2Modified,
					grading3Modified: item.grading3Modified,
					gradingTypeModified: item.gradingTypeModified,
					toleranceModified: item.toleranceModified,
					gradingBaseSizeModified: item.gradingBaseSizeModified,
					baseSizeModified: item.baseSizeModified,
					sizeCategoryIdModified: item.sizeCategoryIdModified,
					unitModified: item.unitModified,
					remarksModified: item.remarksModified,
					ordering: item.ordering,
					minUnitId: item.minUnitId,
					tolerance: item.tolerance,
					sizeValueList: measurement.sizeList?.map((size, index) => ({
						...size,
						value: item.sizeValueList[index]?.value || '',
						modified: item.sizeValueList[index]?.modified || false,
						isNew: false
					})),
					baseSize: measurement.baseSize,
					fitTypeId: measurement.id,
					remarks: item.remarks,
					grading1: item.grading1,
					grading2: item.grading2,
					grading3: item.grading3,
					gradingType: item?.gradingType || {
						name: 'Parallel & Proportional',
						constant: 'PARALLEL_PROPORTIONAL'
					},
					status: measurement.status
				};
				break;
			}
		}
	}
	return fitInfo;
};

export const processMeasurementData = (data = []) => {
	let tmpData = [];
	if (data?.length > 0) {
		data[0].data.map((item) => {
			tmpData.push({
				pomResponse: { ...item.pomResponse },
				pomResponseModified: item.pomResponseModified,
				pomResponseOrderingModified: item.pomResponseOrderingModified,
				pomResponseNameModified: item.pomResponseNameModified,
				fitInfo: getFitInfoByPomId(data, item.pomResponse.id)
			});
		});
	}
	return tmpData;
};

export const processFitWiseSizeList = (data = []) => {
	let sizeListInfo = {};
	if (data?.length > 0) {
		for (let measurement of data) {
			sizeListInfo[measurement.fitType.constant] = {
				sizeList: measurement.sizeList,
				baseSize: measurement.baseSize,
				fitTypeId: measurement.id,
				groupGradingBaseSize: measurement.gradingBaseSize
			};
		}
	}
	return sizeListInfo;
};

export const onUpdateMeasurementTable = (payload) => async (dispatch) => {
	dispatch({
		type: Types.UPDATE_MEASUREMENT_TABLE,
		payload: payload
	});
};

export const onAddChangeLogOnDuplicate = (payload) => async (dispatch) => {
	dispatch({
		type: Types.ADD_CHANGE_LOG_ON_DUPLICATE,
		payload: payload
	});
};
export const convertMeasurementSizeType = (data) => async (dispatch) => {
	dispatch({
		type: Types.CONVERT_MEASUREMENT_SIZE_TO,
		payload: data
	});
};

export const convertMeasurementSizeTypeChangeLog = (data) => async (dispatch) => {
	dispatch({
		type: Types.CONVERT_MEASUREMENT_SIZE_CHANGE_LOG,
		payload: data
	});
};

export const updateSizeWiseValue = (data) => async (dispatch) => {
	dispatch({
		type: Types.CONVERT_MEASUREMENT_SIZE_VALUE,
		payload: data
	});
};

export const toggleBlockUsedFromInfo = (data) => async (dispatch) => {
	dispatch({
		type: Types.IS_SHOW_BLOCK_USED_FROM,
		payload: data
	});
};

export const hideMeasurementTableColumn = (data) => async (dispatch) => {
	dispatch({
		type: Types.HIDE_MEASUREMENT_TABLE_COLUMNS,
		payload: data
	});
};

export const showAllMeasurementTableColumn = (data) => async (dispatch) => {
	dispatch({
		type: Types.SHOW_ALL_MEASUREMENT_TABLE_COLUMN,
		payload: data
	});
};
